"use client";
import Header from "./Header";
import ObituaryHeader from "./ObituaryHeader";
import CommonHeader from "./CommonHeader";

import TopBar from "./TopBar";
import Header7 from "./Header7";

import Footer from "./Footer";
import CompanyFooter from "./CompanyFooter";

import DrawerDialoge from "./DrawerDialoge";
import { useState, useEffect } from "react";
import PopUp from "@/app/components/appcomponents/popup";
import MessagePopUp from "@/app/components/appcomponents/MessagePopup";
import {
  LocalQuickReview,
  LocalQuickReviewModal,
} from "@/app/components/appcomponents/LocalQuickReview";
import MemoryHeader from "./MemoryHeader";
import { useAuth } from "@/hooks/useAuth";
import SideMenu from "../ui/sideMenu";
import CommonFooter from "./CommonFooter";
import { OglasevalciHeader } from "@/app/components/appcomponents/Header";

const Layout = ({
  children,
  from,
  forFooter,
  isMegaMenuVisible,
  megaMenu,
  showHamburger = true,
  data = {},
  onChangeMemory = () => {},
  currentPage = "",
  handleCloseModal = () => {},
  isModalLayout = false,
  // The banner of the pages with from="23" (Cenik by default; "Novosti in izboljšave" gives its own).
  heroTitle = "Cenik",
  heroImage = "/payment-hero.jpg",
}) => {
  const { user, isAuthenticated } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isMessageModalVisible, setIsMessageModalVisible] = useState(false);
  const [isLocalQuickModalVisible, setIsLocalQuickModalVisible] =
    useState(false);
  const [isLocalQuickReviewModalVisible, setIsLocalQuickReviewModalVisible] =
    useState(false); // Fixed prop name

  const OnDrawerButtonClicked = (item) => {
    console.log(item.name);
  };

  return (
    <div className="main-wrapper flex flex-col min-h-screen w-full">
      {/* Headers */}
      {from == "1" || from == "2" ? (
        <div className="fixed top-0 z-50 flex w-full justify-center">
          <TopBar
            setIsModalVisible={setIsModalVisible}
            setIsMessageModalVisible={setIsMessageModalVisible}
            setIsLocalQuickModalVisible={setIsLocalQuickModalVisible}
            setIsLocalQuickReviewModalVisible={
              setIsLocalQuickReviewModalVisible
            } // Fixed prop name
          />
        </div>
      ) : null}

      {from == "1" ? (
        <Header
          isMegaMenuVisible={isMegaMenuVisible}
          onMenuCLick={megaMenu}
          from={from}
        />
      ) : from == "5" ? (
        <Header7
          handleCloseModal={isModalLayout ? handleCloseModal : undefined}
          data={data}
          from={5}
          showHamburger={showHamburger}
        />
      ) : from == "7" ? (
        <Header7
          handleCloseModal={isModalLayout ? handleCloseModal : undefined}
          data={data}
          from={7}
          showHamburger={showHamburger}
        />
      ) : from == "3" ? (
        <MemoryHeader onChange={onChangeMemory} />
      ) : from == "18" ? (
        // CommonHeader now handles its own modals
        <CommonHeader currentPage={currentPage} />
      ) : (
        <>
          {from == "2" ? <div className="flex h-[45px]" /> : null}
          <ObituaryHeader from={from} />
        </>
      )}

      {/* Modals for non-CommonHeader pages */}
      {from !== "18" && (
        <>
          {isModalVisible && (
            <div className="flex">
              <PopUp setIsModalVisible={setIsModalVisible} />
            </div>
          )}

          {isMessageModalVisible && (
            <div className="flex">
              <MessagePopUp
                setIsMessageModalVisible={setIsMessageModalVisible}
              />
            </div>
          )}

          {isLocalQuickModalVisible && !user?.city && (
            <div className="flex">
              <LocalQuickReview
                setIsLocalQuickModalVisible={setIsLocalQuickModalVisible}
              />
            </div>
          )}

          {isLocalQuickReviewModalVisible &&
            isAuthenticated &&
            user?.city && ( // Fixed prop name
              <div className="flex">
                <LocalQuickReviewModal
                  setIsLocalQuickReviewModalVisible={
                    setIsLocalQuickReviewModalVisible
                  }
                />
              </div>
            )}
        </>
      )}

      {from == "23" ? (
        <>
          {/* <CommonHeader currentPage={currentPage} /> */}
          <div className="absolute top-0 left-0 w-full">
            <OglasevalciHeader arrowOnly={true} />
          </div>
          <div className="flex relative mobile:h-[196px] tablet:h-[220px] desktop:h-[300px] mt-[73px] tablet:mt-[80px] mobile:mt-[55px] desktop:mt-[91px] w-full min-w-full max-w-full mx-auto mobile:z-50 mobile:relative">
            <img
              className="object-cover h-full w-full"
              src={heroImage}
              alt={`Ozadje za sekcijo ${heroTitle} - Osmrtnica.com`}
              style={{
                objectFit: "cover",
                objectPosition: "center",
                minWidth: "100%",
                maxWidth: "100%",
              }}
            />
            <h1
              className={`absolute text-[#1E2125] border border-[#ffffff] top-[35%] mx-auto left-0 right-0 flex items-center justify-center bg-gradient-to-r from-[#ffffff] to-[#ffffff]/[30%] rounded-[8px] ${
                heroTitle === "Cenik" ?
                  "mobile:text-[28px] text-[40px] mobile:w-[114px] mobile:h-[65px] w-[137px] h-[79px]"
                : "mobile:text-[22px] text-[30px] w-fit px-6 mobile:px-4 py-3 text-center"
              }`}
            >
              {heroTitle}
            </h1>
          </div>
        </>
      ) : null}

      <main className="main-content flex flex-grow bg-[#F5F7F9]">
        {children}
      </main>

      {/* Footer */}
      {forFooter == "company" ? (
        <CompanyFooter data={data} />
      ) : forFooter == "memorypage" ? null : forFooter === "cenikpage" ? (
        <CommonFooter currentPage="/cenik" />
      ) : (
        <Footer />
      )}

      <DrawerDialoge
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        OnDrawerButtonClicked={OnDrawerButtonClicked}
      />
    </div>
  );
};

export default Layout;
